import { ClientGroupDto } from '@/models/client/ClientGroupDto';
import { ClientGroupDropdownDto } from '@/models/client/ClientGroupDropdownDto';
import { CrudServiceBase } from './CrudServiceBase';

export class ClientGroupService extends CrudServiceBase<ClientGroupDto> { 
  constructor() {
    super('/api/ClientGroups');
  }

  async getDropdownData(clientId: Guid) : Promise<ClientGroupDropdownDto> {
    return await this.client.get(`/dropdown/${clientId}`);
  }
}